import FilterTabItem from './components/FilterTabItem';

export interface IFilterTabItem {
  title: string;
  id: string | number;
}

export interface FilterTabProps {
  items: Readonly<IFilterTabItem[]>;
  active?: IFilterTabItem;
  onChange(item: IFilterTabItem['id'], index: number): void;
  disabled?: boolean;
}

export default function FilterTab({
  items,
  active,
  onChange,
  disabled,
}: FilterTabProps) {
  return (
    <div
      style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr)` }}
      className="grid w-fit min-w-max rounded-lg border border-[#F2F4F6] bg-white dark:border-[#FFFFFF0A] dark:bg-[#FFFFFF14]"
    >
      {items.map((item, index) => (
        <FilterTabItem
          key={item.id}
          title={item.title}
          active={(active && active.id === item.id) || false}
          onClick={() => onChange(item.id, index)}
          disabled={disabled}
        />
      ))}
    </div>
  );
}
